import React from 'react';
type PendingMarkerProps = {
  children: React.ReactNode;
  className?: string;
};
/** Etichetta visibile solo nella vista di lavoro per i contenuti da confermare. */
export function PendingMarker({
  children,
  className = ''
}: PendingMarkerProps) {
  return <span className={`inline-flex items-center rounded-full border border-dashed border-berry-deep/50 bg-cream px-2.5 py-0.5 text-[11px] font-semibold text-berry-deep ${className}`} data-id="element-191" data-mp="30d20lq2tr1ua">
      {children}
    </span>;
}